import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 17px;
`
